import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Row,
  Col,
  Label
} from "reactstrap";
import { validateGiftReceiverForm } from "constantFunctions/formValidations";

function AddOrUpdateGiftReceiverModal(props) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

useEffect(() => {
  if (props.data) {
    setFirstName(props.data.firstName || "");
    setLastName(props.data.lastName || "");
    setEmail(props.data.email || "");
    setPhone(props.data.phone || "");
  }
}, []);

  const addOrUpdateGiftReceiverHandler = (e) => {
    let body = {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      email: email.trim(),
      phone: phone.trim()
    };
    let validation = validateGiftReceiverForm(body);
    if (validation.success) {
      let apiEndpoint = "gift-receivers/create";
      if (props.data && props.data.id > 0) {
        apiEndpoint = `gift-receivers/update/${props.data.id}`;
      }
      PostApiWithAuthorizationAction(apiEndpoint, body)
      .then((res) => {
        if (res.err) {
          toast.error(res.err, {
            position: toast.POSITION.TOP_CENTER,
          });
        } else {
          //toast.success(res.message);
          props.refreshData({});
          props.toggle(e);
        }
      })
      .catch((err) => {
        if (err.status === 440) {
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        } else {
          toast.error("Something went wrong! /n Please clear and retry", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      });
    } else {
      toast.error(validation.err, {
        position: toast.POSITION.TOP_CENTER,
        closeOnClick: true,
        autoClose: 8000,
      });
    }
  };

  return (
    <Modal isOpen={props.show} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>{props.data && props.data.id > 0 ? "Edit Gift Receiver" : "Add New Gift Receiver"}</ModalHeader>
      <ModalBody>
        <Row className="">
            <Col md="12" className="mb-0">
                <FormGroup className="mb-0">
                    <Label className="form-control-label" for="firstName">First Name</Label>
                    <Input
                        id="firstName"
                        type="text"
                        placeholder="First Name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                    />
                    <span className="text-danger">
                        <small>*required</small>
                    </span>
                </FormGroup>
            </Col>
            <Col md="12" className="mb-0">
                <FormGroup className="mb-0">
                    <Label className="form-control-label" for="lastName">Last Name</Label>
                    <Input
                        id="lastName"
                        type="text"
                        placeholder="Last Name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                    />
                    <span className="text-danger">
                        <small>*required</small>
                    </span>
                </FormGroup>
            </Col>
        </Row>
        <FormGroup className="mb-0">
            <Label className="form-control-label" for="email">Email</Label>
            <Input
                id="email"
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
        </FormGroup>
        <FormGroup className="mb-0">
            <Label className="form-control-label" for="phone">Phone</Label>
            <Input
                id="phone"
                type="text"
                placeholder="Phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
            />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button
        id="add-btn"
          color="primary"
          onClick={addOrUpdateGiftReceiverHandler}
          disabled={firstName.length === 0 || lastName.length === 0}
        >
            {props.data && props.data.id > 0 ? "Update" : "Add"}
        </Button>{" "}
        <Button color="secondary" onClick={props.toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default AddOrUpdateGiftReceiverModal;
